import React from 'react';
import PropTypes from 'prop-types';

const PointTitleBar = (props) => {

    const generateMarkup = (markup)=>{
        return {
            __html: markup
        }
    };

    const title = props.currentlyPlaying.postData.title.rendered;

    return(
        <div className="app-point-title">
                        <div className="point-actions-header">
                            <button
                                className="point-menu"
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    float: 'right'
                                }}>
                                <i className="fa fa-ellipsis-v" aria-hidden="true" />
                            </button>
                            <button
                                onClick={props.onClosePlayer}
                                className="point-menu"
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    float: 'right'
                                }}>
                                <i className="fa fa-times" aria-hidden="true" />
                            </button>
                        </div>
                        <div
                            onClick={props.onPlayerMode}
                            className="point-data">
                            <img
                                style={{
                                    width: '50px',
                                    height: '50px',
                                    float: 'left'
                                }}
                                src={props.currentlyPlaying.banner}
                                alt="title" />
                            <b dangerouslySetInnerHTML={generateMarkup(title)}></b>
                            <br />
                            {/*
                            {props.subTitle}
                            */}
                        </div>
                    </div>
    )
};

export default PointTitleBar;

PointTitleBar.propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    currentlyPlaying: PropTypes.object.isRequired
    //playerMode: PropTypes
}




// WEBPACK FOOTER //
// ./src/components/shared/PointAudio/PointTitleBar.js